import { IShortcutDescriptorGroup } from "../../../utils/shortcut-manager/interfaces/IShortcutDescriptorGroup";
import { launchDialog } from "../../dialog-factories/LaunchDialog.function";
import { DialogSize } from "../../dialog-instance/enums/DialogSize";
import { ButtonClass } from "../../../enums/ButtonClass";
import { IShortcutViewerModel } from "../interfaces/IShortcutViewerModel";
import { coreUiI18n } from "../../i18n/CoreUiI18n.const";

export const launchShortcutViewer = (element: HTMLElement, shortcuts: Array<IShortcutDescriptorGroup>): void => {
    launchDialog<IShortcutViewerModel>({
        size: DialogSize.Medium,
        title: coreUiI18n.getString("shortcut_viewer.dialog_title"),
        component: () => import("../ShortcutViewerDialogContent.component").then((module) => module.ShortcutViewerDialogContent),
        initialModel: {
            shortcutGroups: shortcuts
        },
        dismissAction: (_, instance) => {
            instance.close(() => {
                if (element !== null && document.body.contains(element)) {
                    element.focus();
                }
            });
        },
        actions: [
            {
                label: coreUiI18n.getString("buttons.close"),
                ariaLabel: coreUiI18n.getString("buttons.close"),
                buttonClass: ButtonClass.Outlined,
                disabled: () => false,
                action: (_, instance) => {
                    instance.close(() => {
                        if (element !== null && document.body.contains(element)) {
                            element.focus();
                        }
                    });
                }
            }
        ]
    });
};
